module.exports = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjE3IiB2aWV3Qm94PSIwIDAgMTMgMTciIHdpZHRoPSIxMyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9IiNkNjBjOGMiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PHBhdGggZD0ibTAgMGg0djE3aC00eiIvPjxwYXRoIGQ9Im05IDBoNHYxN2gtNHoiLz48L2c+PC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ../core/src/assets/images/global-pause.svg
// module id = 467
// module chunks = 0